<template>
  <div class="filtros-ativos" v-if="filtros.length">
    <span class="filtros-ativos__label">{{ $t('relatorios.filtrosAtivos') }}:</span>
    <span v-for="(f, i) in filtros" :key="f.label" class="filtros-ativos__item">
      <b>{{ f.label }}:</b> {{ f.value }}<span v-if="i < filtros.length - 1" class="filtros-ativos__sep"> | </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'FiltrosAtivos',
  props: {
    filtros: { type: Array, default: () => [] }, // [{ label, value }]
  },
}
</script>

<style lang="scss" scoped>
.filtros-ativos {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  font-size: 13px;
  color: #C7C7D8;
  margin-bottom: 16px;

  &__label {
    font-weight: 600;
    color: #7C7C8A;
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.5px;
    margin-right: 4px;
  }

  &__item {
    b {
      color: #fff;
      font-weight: 600;
    }
  }

  &__sep {
    color: #7C7C8A;
    margin: 0 2px;
  }
}
</style>
